import { render, staticRenderFns } from "./RFIDBatchScanner.vue?vue&type=template&id=7bc4fc4f&scoped=true"
import script from "./RFIDBatchScanner.vue?vue&type=script&lang=js"
export * from "./RFIDBatchScanner.vue?vue&type=script&lang=js"
import style0 from "./RFIDBatchScanner.vue?vue&type=style&index=0&id=7bc4fc4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc4fc4f",
  null
  
)

export default component.exports